"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Order_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Order = exports.DEFAULT_BOOKING_REFERENCE_LENGTH = exports.LEGACY_BOOKING_REFERENCE_LENGTH = exports.OrderPriceCalculationValidationOptions = exports.OrderValidationGroup = void 0;
exports.getChildSeatsForOrder = getChildSeatsForOrder;
exports.isAirportTransfer = isAirportTransfer;
const constants_1 = require("@daytrip/constants");
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const statusGetter_1 = require("../statusGetter");
const transformToDate_1 = require("../transformers/transformToDate");
const AtLeastOneAdultPerVehicle_1 = require("../validators/AtLeastOneAdultPerVehicle");
const AffiliateConversion_1 = require("./AffiliateConversion");
const DayTripPricingData_1 = require("./DayTripPricingData");
const DynamicPricingInputs_1 = require("./DynamicPricingInputs");
const Location_1 = require("./Location");
const OrderAutomaticEmail_1 = require("./OrderAutomaticEmail");
const OrderCommission_1 = require("./OrderCommission");
const OrderContentLocation_1 = require("./OrderContentLocation");
const OrderCustomLocation_1 = require("./OrderCustomLocation");
const Passenger_1 = require("./Passenger");
const Position_1 = require("./Position");
const RequestHeader_1 = require("./RequestHeader");
const TravelEstimates_1 = require("./TravelEstimates");
const VehicleTypeCoefficient_1 = require("./VehicleTypeCoefficient");
const VehicleTypePriceFee_1 = require("./VehicleTypePriceFee");
var OrderValidationGroup;
(function (OrderValidationGroup) {
    // Anonymous = "Anonymous",
    OrderValidationGroup["PriceCalculation"] = "PriceCalculation";
    OrderValidationGroup["BookingOrder"] = "BookingOrder";
})(OrderValidationGroup || (exports.OrderValidationGroup = OrderValidationGroup = {}));
exports.OrderPriceCalculationValidationOptions = {
    skipMissingProperties: true,
    groups: [OrderValidationGroup.PriceCalculation],
};
exports.LEGACY_BOOKING_REFERENCE_LENGTH = 6;
exports.DEFAULT_BOOKING_REFERENCE_LENGTH = 8;
let Order = Order_1 = class Order {
    _id = (0, uuid_1.v4)();
    createdAt = new Date();
    userId;
    offerType;
    offerId;
    bundleId;
    departureAt = (() => {
        const date = new Date();
        date.setUTCHours(9, 0, 0, 0);
        return date;
    })();
    routeId;
    originLocationId;
    originLocation;
    destinationLocation;
    destinationLocationId;
    // TODO @MaxLength
    pickupAddress = "";
    // TODO @MaxLength
    dropoffAddress = "";
    passengers = [];
    vehicles = [];
    currency = legacy_enums_1.Currency.Euro;
    currencyRate = 1;
    pricingCurrency = legacy_enums_1.Currency.Euro;
    customerNote = "";
    managementNote = "";
    driverNote = "";
    flightNumber;
    customQuoteId = "";
    automaticEmails = [];
    requestHeader;
    paymentMethod = legacy_enums_1.PaymentMethod.Cash;
    type = legacy_enums_1.OrderType.Private;
    tollPrice = 0;
    tollFee = 0;
    additionalPrice = 0;
    additionalFee = 0;
    discountCode = ""; // whatever the customer filled out; if accepted, discountId will be in discountIds
    discountIds = [];
    referralCode = ""; // whatever the customer filled out; if accepted, referralCodeId will be set
    referralCodeId;
    vehicleTypesPricesFees = [];
    totalPrice;
    /**
     * The base amount allocated to the service provider (e.g., driver) for the service.
     * Contributes to `totalPrice`. `price` + `fee` represents the base customer charge before extras.
     */
    price;
    /**
     * Daytrip's fee or commission earned on the base service.
     * Contributes to `totalPrice`. `price` + `fee` represents the base customer charge before extras.
     */
    fee;
    priceAdjustmentCoefficient;
    feeAdjustmentCoefficient;
    vehicleCoefficients = [];
    priceType = legacy_enums_1.PricingType.Flexible;
    contentLocations = [];
    customLocations = [];
    acceptedAt;
    declinedAt;
    confirmedAt;
    cancelledAt;
    draftedAt;
    reservedAt;
    autoExpireAt;
    createdBy;
    isDepositRequired;
    pickupAddressType;
    airportTransferDirection;
    dropoffAddressType;
    meetingPositionId;
    dropoffPositionId;
    isFeedbackRequestDisabled;
    departureDateChangedLessThan24hUntilDeparture;
    pricingCountryId;
    pricingRegionId;
    version = 0;
    apiPartnerId;
    // id in the system of the API partner
    externalId;
    pickupPosition;
    dropoffPosition;
    customMarkup; // additional markup on top of our price in EUR
    emailVerificationCode;
    isCustomerEmailVerified;
    partnerId;
    gclid;
    isBusinessTrip;
    preferredQuality;
    hostAgencyId;
    travelAgentId;
    // set only for orders created via Partner API V3
    tripOptionId;
    travelEstimates;
    // set only for orders created as a result of affiliate link conversion (via Trackdesk)
    affiliateConversion;
    isVIP = false;
    dynamicPricing;
    dayTripPricingData;
    cancellationInfo;
    commission;
    locale = legacy_enums_1.DEFAULT_LANGUAGE;
    customerCountryIso;
    hoursRented;
    bookingReference = (0, utils_1.generateShortId)(exports.DEFAULT_BOOKING_REFERENCE_LENGTH);
    amplitudeDeviceId;
    get leadPassenger() {
        let leadPassenger = this.passengers.find((p) => p.isLead());
        if (!leadPassenger) {
            leadPassenger = this.passengers.find((p) => p.isAdult());
        }
        return leadPassenger;
    }
    get status() {
        return (0, statusGetter_1.statusGetter)(this, Order_1, legacy_enums_1.OrderStatus);
    }
    static statusPrototype(status) {
        const now = new Date();
        switch (status) {
            case legacy_enums_1.OrderStatus.Cancelled:
                return {
                    cancelledAt: now,
                };
            case legacy_enums_1.OrderStatus.Declined:
                return {
                    cancelledAt: undefined,
                    declinedAt: now,
                };
            case legacy_enums_1.OrderStatus.Draft: {
                return {
                    cancelledAt: undefined,
                    declinedAt: undefined,
                    acceptedAt: undefined,
                    confirmedAt: undefined,
                    draftedAt: now,
                    reservedAt: undefined,
                };
            }
            case legacy_enums_1.OrderStatus.Accepted:
                return {
                    cancelledAt: undefined,
                    declinedAt: undefined,
                    acceptedAt: now,
                    confirmedAt: undefined,
                };
            case legacy_enums_1.OrderStatus.Confirmed:
                return {
                    cancelledAt: undefined,
                    declinedAt: undefined,
                    acceptedAt: now,
                    confirmedAt: now,
                };
            case legacy_enums_1.OrderStatus.Reserved: {
                return {
                    acceptedAt: undefined,
                    confirmedAt: undefined,
                    cancelledAt: undefined,
                    declinedAt: undefined,
                    reservedAt: now,
                    autoExpireAt: now,
                };
            }
            case legacy_enums_1.OrderStatus.Pending:
            default:
                return {
                    cancelledAt: undefined,
                    declinedAt: undefined,
                    acceptedAt: undefined,
                    confirmedAt: undefined,
                    draftedAt: undefined,
                    reservedAt: undefined,
                };
        }
    }
    isCanceled() {
        return !!this.cancelledAt;
    }
    get isLite() {
        return this.vehicles.some((vehicleType) => vehicleType === legacy_enums_1.VehicleType.SedanLite);
    }
    get areAllPassengersAssigned() {
        return this.passengers.every((passenger) => passenger.assignationId);
    }
    get areSomePassengersAssigned() {
        return this.passengers.some((passenger) => passenger.assignationId);
    }
    get isB2B() {
        return !!this.travelAgentId || !!this.hostAgencyId || !!this.affiliateConversion;
    }
};
exports.Order = Order;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "_id", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)(({ value }) => new Date(value)),
    __metadata("design:type", Date)
], Order.prototype, "createdAt", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsOptional)({
        groups: [OrderValidationGroup.PriceCalculation],
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "userId", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.OfferType),
    __metadata("design:type", Number)
], Order.prototype, "offerType", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)(
    // So far we support only flexible offers
    // once the same concept of offers is introduced for managed offerings
    // we need to validate offerId in every instance
    (order) => order.offerType === legacy_enums_1.OfferType.Flexible),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "offerId", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], Order.prototype, "bundleId", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)(({ value }) => new Date(value)),
    __metadata("design:type", Date)
], Order.prototype, "departureAt", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsOptional)({
        groups: [OrderValidationGroup.BookingOrder],
    }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "routeId", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "originLocationId", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => Location_1.Location, { nullable: true }),
    __metadata("design:type", Location_1.Location)
], Order.prototype, "originLocation", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => Location_1.Location, { nullable: true }),
    __metadata("design:type", Location_1.Location)
], Order.prototype, "destinationLocation", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "destinationLocationId", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? "" : value)),
    __metadata("design:type", String)
], Order.prototype, "pickupAddress", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? "" : value)),
    __metadata("design:type", String)
], Order.prototype, "dropoffAddress", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)(() => [Passenger_1.Passenger]),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_validator_1.IsOptional)({
        groups: [OrderValidationGroup.PriceCalculation],
    }),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Passenger_1.Passenger),
    __metadata("design:type", Array)
], Order.prototype, "passengers", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => [type_graphql_1.Int]),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.ArrayNotEmpty)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.Validate)(AtLeastOneAdultPerVehicle_1.AtLeastOneAdultPerVehicle),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Array)
], Order.prototype, "vehicles", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "currency", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "currencyRate", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "pricingCurrency", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.MaxLength)(constants_1.MAX_CUSTOMER_NOTE_LENGTH),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "customerNote", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "managementNote", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "driverNote", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "flightNumber", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "customQuoteId", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => [OrderAutomaticEmail_1.OrderAutomaticEmail]),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => value ?? []),
    (0, class_transformer_1.Type)(() => OrderAutomaticEmail_1.OrderAutomaticEmail),
    __metadata("design:type", Array)
], Order.prototype, "automaticEmails", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => RequestHeader_1.RequestHeader),
    __metadata("design:type", RequestHeader_1.RequestHeader)
], Order.prototype, "requestHeader", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "paymentMethod", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "type", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "tollPrice", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "tollFee", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "additionalPrice", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "additionalFee", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.MaxLength)(18),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "discountCode", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)(() => [String]),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (!value ? [] : value)),
    __metadata("design:type", Array)
], Order.prototype, "discountIds", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.MaxLength)(18),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "referralCode", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "referralCodeId", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)(() => [VehicleTypePriceFee_1.VehicleTypePriceFee], { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => VehicleTypePriceFee_1.VehicleTypePriceFee),
    __metadata("design:type", Array)
], Order.prototype, "vehicleTypesPricesFees", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "totalPrice", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "price", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "fee", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)()
    // this field is applicable for dynamic pricing. we need it here because some orders do not have offer but they have this price adjustment coefficient
    ,
    __metadata("design:type", Number)
], Order.prototype, "priceAdjustmentCoefficient", void 0);
__decorate([
    (0, type_graphql_1.Authorized)(),
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)()
    // this field is applicable for dynamic pricing. we need it here because some orders do not have offer but they have this fee adjustment coefficient
    ,
    __metadata("design:type", Number)
], Order.prototype, "feeAdjustmentCoefficient", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => [VehicleTypeCoefficient_1.VehicleTypeCoefficient], { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => VehicleTypeCoefficient_1.VehicleTypeCoefficient),
    __metadata("design:type", Array)
], Order.prototype, "vehicleCoefficients", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => String),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "priceType", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => [OrderContentLocation_1.OrderContentLocation], { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => OrderContentLocation_1.OrderContentLocation),
    __metadata("design:type", Array)
], Order.prototype, "contentLocations", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => [OrderCustomLocation_1.OrderCustomLocation], { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => OrderCustomLocation_1.OrderCustomLocation),
    __metadata("design:type", Array)
], Order.prototype, "customLocations", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)()
    // @IsDate()
    ,
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Order.prototype, "acceptedAt", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)()
    // @IsDate()
    ,
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Order.prototype, "declinedAt", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)()
    // @IsDate()
    ,
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Order.prototype, "confirmedAt", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)()
    // @IsDate()
    ,
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Order.prototype, "cancelledAt", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Order.prototype, "draftedAt", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Order.prototype, "reservedAt", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Order.prototype, "autoExpireAt", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "createdBy", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Order.prototype, "isDepositRequired", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (value == null ? undefined : value)),
    __metadata("design:type", Number)
], Order.prototype, "pickupAddressType", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.AirportTransferDirection),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "airportTransferDirection", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (value == null ? undefined : value)),
    __metadata("design:type", Number)
], Order.prototype, "dropoffAddressType", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((order) => order.pickupAddressType === legacy_enums_1.LocationAddressType.MeetingPosition),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "meetingPositionId", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((order) => order.dropoffAddressType === legacy_enums_1.LocationAddressType.MeetingPosition),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "dropoffPositionId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Order.prototype, "isFeedbackRequestDisabled", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Order.prototype, "departureDateChangedLessThan24hUntilDeparture", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "pricingCountryId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "pricingRegionId", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Order.prototype, "version", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], Order.prototype, "apiPartnerId", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], Order.prototype, "externalId", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => Position_1.Position, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", Object)
], Order.prototype, "pickupPosition", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => Position_1.Position, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", Object)
], Order.prototype, "dropoffPosition", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], Order.prototype, "customMarkup", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], Order.prototype, "emailVerificationCode", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], Order.prototype, "isCustomerEmailVerified", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsUUID)("4"),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "partnerId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "gclid", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Order.prototype, "isBusinessTrip", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => String, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.OrderPreferredQuality),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "preferredQuality", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "hostAgencyId", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "travelAgentId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "tripOptionId", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => TravelEstimates_1.TravelEstimates, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", TravelEstimates_1.TravelEstimates)
], Order.prototype, "travelEstimates", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => AffiliateConversion_1.AffiliateConversion, { nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", AffiliateConversion_1.AffiliateConversion)
], Order.prototype, "affiliateConversion", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Order.prototype, "isVIP", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", DynamicPricingInputs_1.DynamicPricingInputs)
], Order.prototype, "dynamicPricing", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DayTripPricingData_1.DayTripPricingData)
    // this is a way to store managed daytrip pricing data at the moment of order creation to facilitate order update
    ,
    __metadata("design:type", DayTripPricingData_1.DayTripPricingData)
], Order.prototype, "dayTripPricingData", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Order.prototype, "cancellationInfo", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => OrderCommission_1.OrderCommission),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", OrderCommission_1.OrderCommission)
], Order.prototype, "commission", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => String),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Languages),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "locale", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "customerCountryIso", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)()
    // this field is for Hourly hire
    ,
    __metadata("design:type", Number)
], Order.prototype, "hoursRented", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "bookingReference", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Order.prototype, "amplitudeDeviceId", void 0);
exports.Order = Order = Order_1 = __decorate([
    (0, type_graphql_1.ObjectType)("Order"),
    (0, type_graphql_1.InputType)("OrderInput"),
    (0, typeorm_1.Entity)("orders")
], Order);
function getChildSeatsForOrder(order) {
    const childSeats = [];
    order.passengers.forEach(({ childSeatType }) => {
        if ((0, utils_1.isUndefinedOrNull)(childSeatType)) {
            return;
        }
        childSeats.push(childSeatType);
    });
    return childSeats;
}
function isAirportTransfer(order) {
    return [legacy_enums_1.AirportTransferDirection.FromAirport, legacy_enums_1.AirportTransferDirection.ToAirport].includes(order.airportTransferDirection ?? legacy_enums_1.AirportTransferDirection.None);
}
//# sourceMappingURL=Order.js.map